import { z } from 'zod';
import { MAX_RIAL } from './money.js';
/**
 * THE money-input validator (CW-06) — the ONE definition of "a valid rial amount from a client", shared by
 * every request schema (schemas.ts) AND the GL subledger schemas (accounting.ts) so they can never disagree
 * on what a valid amount is. A rial is a finite INTEGER (the whole money model is integer — no decimals, see
 * money.ts) within range: `> 0` (or `>= 0` when `positive: false`) and `<= MAX_RIAL` (above 2^53 node:sqlite
 * throws on READ and bricks the table). So a fractional / Infinity / NaN / negative / >2^53 rial can never
 * reach the store from ANY edge. Before this, `schemas.ts` used a near-identical helper that omitted `.int()`,
 * letting a fractional rial through the deal / PO / customer schemas while the ledger rejected it.
 *
 * `positive` toggles the >0 rule: a price/qty is > 0; a discount / credit-limit / opening amount is >= 0.
 */
export const rialInput = (label = 'مبلغ نامعتبر است', { positive = true } = {}) => {
    const base = z
        .number({ invalid_type_error: label })
        .finite(label)
        .int('مبلغ باید عدد صحیح ریال باشد')
        .max(MAX_RIAL, 'مبلغ خارج از محدودهٔ مجاز است');
    return positive ? base.positive(label) : base.nonnegative(label);
};
/**
 * A QUANTITY — deliberately NOT money: finite and positive but NOT an integer, because materials are bought
 * and consumed per kg, so a fractional quantity is legitimate (the AP tie-out rounds qty×price per row). The
 * MAX_RIAL cap is only a sane Infinity/overflow guard, not a money bound.
 */
export const quantityInput = (label = 'مقدار باید بزرگ‌تر از صفر باشد') => z.number({ invalid_type_error: label }).finite(label).positive(label).max(MAX_RIAL, label);
//# sourceMappingURL=moneySchema.js.map